import React, {Component} from "react"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faExternalLinkAlt, faUndo} from '@fortawesome/free-solid-svg-icons'
import {Row} from "react-bootstrap"
import ProviderSlider from "./ProviderSlider";
import Message from "./Message";
import TypingMessage from "./TypingMessage";
import CancelButton from "./CancelButton";
import Feedback from "./Feedback";
import {getTimeAMPMFormat, jsonParse} from "../utils/commonHelper";
import {i18n, keydownHandler} from "../utils/commonHelper";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import {getAgentAwayMessage} from "./AgentAwayMessage";
import {getAgentHelloMessage} from "./AgentHelloMessage";

export const CONTENT_TYPE_CAROUSEL = 'corusel'
export const CONTENT_TYPE_TYPING = 'typing'
export const CONTENT_TYPE_TEXT = 'text/plain'
export const CONTENT_TYPE_PLAIN_TEXT = 'PlainText'
export const CONTENT_TYPE_JOINED = 'application/vnd.amazonaws.connect.event.participant.joined'
export const CONTENT_TYPE_LEFT = 'application/vnd.amazonaws.connect.event.participant.left'
export const CONTENT_TYPE_TRANSFER = 'transfer'
export const CONTENT_TYPE_FEEDBACK = 'feedback'
export const CONTENT_TYPE_TRANSFER_SUCCEEDED = 'application/vnd.amazonaws.connect.event.transfer.succeeded'
export const CONTENT_TYPE_TRANSFER_FAILED = 'application/vnd.amazonaws.connect.event.transfer.failed'
export const CONTENT_TYPE_EVENT = 'EVENT'
export const CONTENT_TYPE_CHAT_ENDED = 'application/vnd.amazonaws.connect.event.chat.ended'
export const ROLE_SYSTEM = "SYSTEM"
export const ROLE_AGENT = "AGENT"
export const ROLE_CUSTOMER = "CUSTOMER"

export default class Template extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ...props,
            buttonClicked: false,
            askNameValue: '',
        }
        this.state.init(this);
    }

    handleClick = (button) => {
        if (!this.state.isSafari) {
            this.setState({
                buttonClicked: true
            });
        }
        const {avatar} = this.props;
        this.props.onButtonClick(button.title, button.url, {avatar: avatar, button: button})
    };

    changeAskNameValue = (e) => {
        this.setState({
            askNameValue: e.target.value
        });
    };

    scrollToBottom = () => {
        try {
            if (this.state.scrollToBottom) {
                this.state.scrollToBottom();
            }
        } catch (e) {}
    }

    renderMessage = (type, data, role, last, buttonClicked, dataKey, avatar, message, username, displayName, isLastInChain, agentConnected, showCancelButton, feedbackValue, showFeedback) => {
        const {showRestartChat, prescription, cancelButtonTitle, askName} = this.props;

        switch (type) {
            case CONTENT_TYPE_CAROUSEL:
                return <ProviderSlider data={data}
                                       buttonClick={this.state.onButtonClick}
                                       role={role}
                                       last={last}
                                       buttonClicked={buttonClicked}
                                       scrollToBottom={this.state.scrollToBottom}
                />
            case CONTENT_TYPE_EVENT:
                return <>
                    <Message data={data} message={message} role={'SYSTEM'} isLastInChain={isLastInChain} avatar={avatar} dataKey={dataKey} />
                    {
                        showCancelButton && last ?
                            <CancelButton title={cancelButtonTitle} cancelLiveChat={this.state.cancelLiveChat} agentConnected={agentConnected} />
                            :
                            ""
                    }
                </>
            case CONTENT_TYPE_JOINED:
                if (role === "AGENT") {
                    if (((type === CONTENT_TYPE_JOINED && !this.state.showCancelButton) && role === ROLE_AGENT && document.getElementsByClassName('cancel-button')[0] !== undefined) || !showCancelButton) {
                        for (const s of document.getElementsByClassName("cancel-button")) {
                            s.style.display = "none";
                        }
                    }
                    if (document.getElementsByClassName('cancel-button')[0] !== undefined && showCancelButton ){
                        for (const s of document.getElementsByClassName("cancel-button")) {
                            s.style.display = "block";
                        }
                    }

                    const messageTextConnected = i18n.__('You are now being connected to a live agent');
                    let messageTextName = "";
                    if (!this.props.queueMessagesLoading) {
                        messageTextName =
                            getAgentHelloMessage(this.props?.baseMessage?.usedQueue, {
                                queueMessages: this.props.queueMessages,
                                startQueueName: this.props.startQueueName,
                                agentName: displayName,
                                customerName: this.props.customerName,
                                language: this.props.language,
                                showTransferMessage: this.props.showTransferMessage,
                                prescription: prescription
                            });
                    }

                    return <>
                        <Message data={data} message={messageTextConnected} role={'SYSTEM'} isLastInChain={false} avatar={avatar} dataKey={dataKey} />
                        <Message data={data} message={messageTextName} role={role} isLastInChain={isLastInChain} avatar={avatar} dataKey={'ms_' + dataKey} />
                    </>
                }
                return <></>
            case CONTENT_TYPE_LEFT:
                if (username === displayName) {
                    let messageText = 'You ended conversation';

                    return <Message data={data} message={messageText} role={'SYSTEM'} isLastInChain={isLastInChain} avatar={avatar} dataKey={dataKey} />
                }
                return <></>
            case CONTENT_TYPE_CHAT_ENDED:
                return <>
                    {
                        this.state.chatEnded && !this.state.showTimeoutMessage ?
                            <div style={{height: "80px", position: "relative"}}>
                                <div className="chat_end_breaker">
                                    Ended by {this.props.chatEndedByCustomer ? 'Customer' : 'Agent'} {getTimeAMPMFormat(new Date())}
                                </div>
                            </div> : ''
                    }
                </>
            case CONTENT_TYPE_TYPING:
                this.scrollToBottom();
                return <TypingMessage />
            case CONTENT_TYPE_TEXT:
                return <>
                    {
                        ((data && !data.hidden) || (data === null)) && <Message data={data} message={message} role={role} isLastInChain={isLastInChain} key={dataKey}/>
                    }
                    {
                        role === ROLE_SYSTEM && last && !buttonClicked && !showCancelButton && data !== null && data.buttons && data.buttons.length ?
                            <Row className={"message-box message-buttons visible"}>
                                {
                                    data.buttons.map((button, key) =>
                                        <React.Fragment key={key} >
                                            {
                                                (data.buttons.length > 1 && button.title === "Start Over") ? <br/> : ""
                                            }
                                            <a
                                                className={"template__href " + button.class}
                                                onKeyDown={keydownHandler}
                                                tabIndex={0}
                                                onClick={() => this.handleClick(button)}>
                                                {
                                                    button?.class === 'btn_start_over' && <
                                                        FontAwesomeIcon icon={faUndo} className="icon"/>
                                                }
                                                {
                                                    button.title
                                                }
                                                {
                                                    button.url && <
                                                        FontAwesomeIcon icon={faExternalLinkAlt}/>
                                                }
                                            </a>
                                        </React.Fragment>
                                    )
                                }
                            </Row>
                            :
                            ""
                    }
                    {
                        showCancelButton && last && role === ROLE_SYSTEM ?
                            <CancelButton title={cancelButtonTitle} cancelLiveChat={this.state.cancelLiveChat} agentConnected={agentConnected} />
                            :
                            ""
                    }
                    {
                        askName && last ?
                            <div className="ask_name">
                                <div className={"ask_name_field " + (this.state.language) + (this.state.askPhone?" phone":"")}>
                                    <div className="ask_name_field_block">
                                        <div className={"title"}>
                                            <AskNameInputTitle data={data} askDOB={this.state.askDOB} askDOBTitle={this.state.askDOBTitle} askPhone={this.state.askPhone} />
                                        </div>
                                        <div className={this.state.askPhone?"phone":""}>
                                            {
                                                this.state.askPhone ?
                                                    <PhoneInput
                                                        placeholder="Enter phone number"
                                                        value={this.state.askNameValue}
                                                        onChange={(value, data, event, formattedValue) =>{
                                                            this.setState({ askNameValue: formattedValue })
                                                        }}
                                                        country="US"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.keyCode === 13) {
                                                                e.preventDefault();
                                                                this.props.sendMessage(this.state.askNameValue, null);
                                                            }
                                                        }}q
                                                        />
                                                    : <input ref={c => this.askNameInputBox = c}
                                                             value={this.state.askNameValue}
                                                             onChange={this.changeAskNameValue}
                                                             onKeyDown={(e) => {
                                                                 if (e.key === 'Enter' || e.keyCode === 13) {
                                                                     e.preventDefault();
                                                                     this.props.sendMessage(this.state.askNameValue, null);
                                                                 }
                                                             }}/>
                                            }
                                            <button
                                                onClick={() => this.props.sendMessage(this.state.askNameValue, null)}>Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            ''
                    }
                </>
            case CONTENT_TYPE_TRANSFER_SUCCEEDED:
                return <div style={{height: "80px", position: "relative"}}>
                    <div className="chat_end_breaker">
                        {message??"Chat transferred by Agent " + getTimeAMPMFormat(new Date(this.props.messageDate))}
                    </div>
                </div>
            case CONTENT_TYPE_FEEDBACK:
                const contactId = this?.props?.baseMessage?.ContactId
                return <>
                    {
                        contactId && showFeedback ?
                            <Feedback feedbackMessage={message}
                                      avatar={avatar}
                                      feedbackValue={feedbackValue}
                                      contactId={contactId}
                                      feedbackConfig={(this.props.config || {}).feedbackConfig}
                                      onUpdateFeedback={this.props.onUpdateFeedback}
                                      feedbackLoaderStatus={this.props.feedbackLoaderStatus}
                                      agents={this.props.agents}
                                      sendFeedback={this.props.sendFeedback}
                                      waitBeforeShow={500}
                                      showCancelFeedback={this.props.showCancelFeedback}
                                      changeFeedbackMessage={this.props.changeFeedbackMessage}
                                      skipFeedback={this.props.skipFeedback}
                                      scrollToBottom={this.scrollToBottom}
                            />
                            :
                            ""
                    }
                </>
            default:
                return <></>
        }
    }
    render = () => {
        const {buttonClicked} = this.state;
        const {
            avatar,
            dataKey,
            username,
            displayName,
            last,
            showCancelButton,
            feedbackValue,
            showFeedback,
            isLastInChain,
            agentConnected
        } = this.props;

        let {role, type, message} = this.props;
        let data = null;

        if (role === 'SYSTEM') {
            data = jsonParse(message)
            if (data?.data) {
                data = data.data?.content;
            }
        }

        if (message === 'CANCEL_LIVE_CHAT') {
            //message = 'Live agent search has been cancelled.';
            data = {
                title: "Live agent search has been cancelled. If this is a medical emergency, please call 911.",
                buttons: [
                    {title: "Go to Home Page", url: "https://atriumhealth.org/?chat=true"}
                ]
            }
            role = ROLE_SYSTEM;
            type = CONTENT_TYPE_TEXT;
        }

        if (message === 'WAITING_AGENT') {
            if (this.props.queueMessagesLoading) {
                message = "";
            } else {
                const usedQueue = this.props?.baseMessage?.usedQueue;
                message = getAgentAwayMessage(usedQueue, {
                    predefinedMessages: this.props.predefinedMessages,
                    queueMessages: this.props.queueMessages,
                    startQueueName: this.props.startQueueName,
                });
            }
            type = CONTENT_TYPE_EVENT;
        }

        if (data?.title && Array.isArray(data.title)) {
            return data.title.map((title, i) => {
                const complexLast = (data.title.length === i + 1) && last;
                return this.renderMessage(type, {}, role, complexLast, buttonClicked, dataKey + '_' + i, avatar, title, username,
                    displayName, data.title[i + 1] ? false : isLastInChain, agentConnected,
                    showCancelButton, feedbackValue, showFeedback
                );
            });
        } else {
            return this.renderMessage(type, data, role, last, buttonClicked, dataKey, avatar, message, username,
                displayName, isLastInChain, agentConnected, showCancelButton, feedbackValue, showFeedback
            );
        }

    }
}

const AskNameInputTitle = ({data, askDOB, askDOBTitle,askPhone}) => {
    let askNameTitle = 'Enter Full Name';
    if (askDOB) {
        askNameTitle = (askDOBTitle) ? askDOBTitle : 'Enter date of birth';
    } else if (data && data.title && data.title.toLowerCase().indexOf('and date of birth') !== -1) {
        askNameTitle = 'Enter Full Name and date of birth';
    } else if (askPhone) {
        askNameTitle = 'Enter phone number';
    }
    return askNameTitle;
}
